import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between pb-4 border-b border-edge-subtle mb-6">
      <div>
        <h1 className="text-h4 text-content-primary">{title}</h1>
        {subtitle && <p className="text-body-sm text-content-tertiary mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
